import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import connectActions from 'utils/connectActions'
import { checkCoupon } from 'actions/coupon'
import Typography from '@material-ui/core/Typography'
import Spacer from 'atoms/Spacer'
import Fade from '@material-ui/core/Fade'
import CircularProgress from '@material-ui/core/CircularProgress'
import Price from 'atoms/Price'
import TextInput from 'atoms/TextInput'
import CheckIcon from '@material-ui/icons/Check'
import CloseIcon from '@material-ui/icons/Close'

const styles = theme => ({
  status: {
    display: 'flex',
    alignItems: 'center',
  },
  statusProgress: {
    marginRight: theme.spacing.unit,
  },
  statusIcon: {
    width: 16,
    height: 16,
    marginRight: theme.spacing.unit,
  }
})

const mapActionsToProps = {
  checkCouponAction: checkCoupon
}

export default
@connectActions(mapActionsToProps, { pure: false })
@withStyles(styles)
class BillingCouponInput extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    checkCouponAction: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    disableOnboarding: PropTypes.bool,
  }

  isCouponValid = (couponData) => {
    const { disableOnboarding } = this.props
    const { valid, metadata } = couponData
    if (!valid) return false
    if (metadata.type === 'ONBOARDING' && disableOnboarding) return false
    return true
  }

  handleSave = async (coupon) => {
    const { checkCouponAction, onChange } = this.props
    onChange('')

    if (!coupon) {
      checkCouponAction.reset()
      return
    }

    try {
      const data = await checkCouponAction.run({ params: [coupon] })
      if (this.isCouponValid(data)) onChange(coupon)
    } catch (e) {
      // do nothing
    }
  }

  inputRef = (node) => {
    if (node) node.focus()
  }

  render() {
    const { checkCouponAction, classes } = this.props
    const { isFailed, isPending, isSucceded, result } = checkCouponAction
    const isValid = isSucceded && this.isCouponValid(result)
    const isInvalid = isSucceded && !result.valid
    const isInvalidOnboardingOnly = isSucceded && !isValid && !isInvalid
    return (
      <Fragment>
        <TextInput
          inputRef={this.inputRef}
          onSave={this.handleSave}
        />

        <Fade in={isPending} mountOnEnter unmountOnExit exit={false}>
          <div>
            <Spacer small />
            <Typography variant="caption" color="textSecondary" component="div" className={classes.status}>
              <CircularProgress className={classes.statusProgress} size={16} color="secondary" />
              Checking promo code...
            </Typography>
          </div>
        </Fade>

        <Fade in={isFailed} mountOnEnter unmountOnExit exit={false}>
          <div>
            <Spacer small />
            <Typography variant="caption" component="div" color="error">
              { checkCouponAction.error && checkCouponAction.error.message }
            </Typography>
          </div>
        </Fade>

        <Fade in={isInvalid} mountOnEnter unmountOnExit exit={false}>
          <div>
            <Spacer small />
            <Typography variant="caption" component="div" color="error" className={classes.status}>
              <CloseIcon className={classes.statusIcon} />
              Coupon is not valid
            </Typography>
          </div>
        </Fade>

        <Fade in={isInvalidOnboardingOnly} mountOnEnter unmountOnExit exit={false}>
          <div>
            <Spacer small />
            <Typography variant="caption" component="div" color="error" className={classes.status}>
              <CloseIcon className={classes.statusIcon} />
              Only valid for new accounts
            </Typography>
          </div>
        </Fade>

        <Fade in={isValid} mountOnEnter unmountOnExit exit={false}>
          <div>
            <Spacer small />
            <Typography variant="caption" component="div" color="primary" className={classes.status}>
              <CheckIcon className={classes.statusIcon} />
              Promo is valid
              { isValid && (
                <Fragment>
                  &nbsp;–&nbsp;
                  <b>
                    <Price
                      amount={result.amount_off}
                      currencyData={{ symbol: result.currency.toUpperCase() === 'USD' ? '$' : result.currency.toUpperCase() }}
                    />
                    {' '}
                    /month
                    {' for '}
                    { result.duration_in_months }
                    {' '}
                    months
                  </b>
                </Fragment>
              ) }
            </Typography>
          </div>
        </Fade>
      </Fragment>
    )
  }
}
